export default __webpack_public_path__ + "static/media/carouselLandscape50.3eaf68f0.png";